var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64,21.433A42.567,42.567,0,1,0,106.567,64,42.615,42.615,0,0,0,64,21.433Zm0,80.912A38.345,38.345,0,1,1,102.345,64,38.389,38.389,0,0,1,64,102.345Z",
    id: "path15",
    style: {
      fill: "#ff0000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.459,48.3a2.11,2.11,0,0,0-2.985,0L64,60.778,51.523,48.3a2.111,2.111,0,1,0-2.985,2.985L61.014,63.763,48.541,76.237a2.111,2.111,0,1,0,2.985,2.985L64,66.748,76.474,79.222a2.111,2.111,0,0,0,2.985-2.985L66.984,63.763,79.459,51.286A2.11,2.11,0,0,0,79.459,48.3Z",
    id: "path17",
    style: {
      fill: "#ff0000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8d6242c2474e127e86fb109ce0f90aed.svg";
export { ForwardRef as ReactComponent };